import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function Load () {
  var router = [
    {
      path: '/',
      name: 'Login',
      component: resolve => require(['../components/System/Login/Login'], resolve),
      meta: {
        title: "登录",
        type: "System",
      },
    },
    {
      path: '/CodeLogin',
      name: 'CodeLogin',
      component: resolve => require(['../components/System/Login/CodeLogin'], resolve),
      meta: {
        title: "登录中",
        type: "System",
      },
    },
    {
      path: '/Bind',
      name: 'Bind',
      component: resolve => require(['../components/Phone/Bind/Index'], resolve),
      meta: {
        title: "身份认证",
        type: "Phone",
      },
    },
  ];
  var system = {
    path: '/System',
    name: 'System',
    component: resolve => require(['../components/System'], resolve),
    meta: {
      title: "",
      type: "System",
    },
    children: [

    ]
  };
  var phone = {
    path: '/Phone',
    name: 'Phone',
    component: resolve => require(['../components/Phone'], resolve),
    meta: {
      title: "",
      type: "Phone",
    },
    children: []
  }
  //加载PC端路由
  var PC = require.context('@/components/System', true, /\.vue$/);
  PC.keys().forEach(key => {
    if (key.indexOf("components") < 0 && !key.endsWith("Login.vue") && !key.endsWith("CodeLogin.vue")) {
      var prop = "";
      if (PC(key).default.props) {
        for (const item in PC(key).default.props) {
          prop += "/:" + item;
        }
      }
      system.children.push({
        path: `/System/${key.replace(/(\.\/|\.vue)/g, '').replace(/-/g, '/')}` + prop,
        name: PC(key).default.name,
        component: resolve => require(["@/components/System/" + key.replace("./", "")], resolve),
        props: true,
        meta: {
          type: "System",
          title: PC(key).default.title ? PC(key).default.title : ""
        }
      });
    }
  });

  //加载手机端路由
  var moble = require.context('@/components/Phone', true, /\.vue$/);
  moble.keys().forEach(key => {
    if (key.indexOf("components") < 0 && key.indexOf("Bind") < 0) {
      var prop = "";
      if (moble(key).default.props) {
        for (const item in moble(key).default.props) {
          prop += "/:" + item;
        }
      }
      phone.children.push({
        path: `/Phone/${key.replace(/(\.\/|\.vue)/g, '').replace(/-/g, '/')}` + prop,
        name: moble(key).default.name,
        component: resolve => require(["@/components/Phone/" + key.replace("./", "")], resolve),
        props: true,
        meta: {
          type: "Phone",
          title: moble(key).default.title ? moble(key).default.title : ""
        }
      });
    }
  });
  system.children.push({
    path: 'NoPower',
    name: "NoPower",
    component: resolve => require(["@/components/System/components/NoPower"], resolve),
    meta: {
      title: "无权访问"
    }
  });
  system.children.push({
    path: '*',
    name: "404",
    component: resolve => require(["@/components/System/components/404"], resolve),
    meta: {
      title: "404"
    }
  });

  phone.children.push({
    path: '*',
    name: "p404",
    component: resolve => require(["@/components/Phone/components/404"], resolve),
    meta: {
      title: "404"
    }
  });

  router.push(system);
  router.push(phone);
  return router
}

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: Load()
})
